
































































































































































































































































































































































import {
  AwsService as awsApi,
  CarpsaleHistoryManagementCarpsaleHistoryService,
  ChatManagementService as chatApi,
} from "@/common/api";
import {
  DATE_TIME_FORMAT_SLASH,
  DATE_TIME_TEXT_FORMAT,
} from "@/common/constant";
import QNotify from "@/common/qNotify";
import {
  formatFileUrl,
  formatImageUrl,
  getShippingUrl,
  getShippingYamatoUrl,
} from "@/common/utils";
import QEditor from "@/components/common/qEditor.vue";
import uploadFile from "@/components/common/uploadFile.vue";
import { TYPES } from "@/model/member";
import {
  DELIVERY_TYPES,
  DELIVERY_TYPES_NAME,
  PAYMENT_TYPES,
  STATUS_NAME,
  STATUS_NAME_LIVECARP,
  STATUSES,
} from "@/model/order";
import { min } from "lodash";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { Component, Vue } from "vue-property-decorator";
// eslint-disable-next-line @typescript-eslint/no-var-requires
import { namespace } from "vuex-class";

const auth = namespace("Auth");

@Component({
  name: "qChat",
  computed: {
    STATUSES() {
      return STATUSES;
    },
    STATUS_NAME() {
      return STATUS_NAME;
    },
    CLEAR_STATUS() {
      if (this.form.comment === "" || this.form.comment?.length === 0) {
        this.statusOrder = null;
      }
    },
  },
  methods: { getShippingYamatoUrl },
  components: {
    uploadFile,
    QEditor,
  },
})
export default class QChat extends Vue {

  get statusOptions() {
    return STATUS_NAME_LIVECARP;
  }

  get addtionalPriceTotal() {
    return this.sumAmount(
      this.order.order_units.filter((unit) =>
        Number.parseInt(unit.addtional_price),
      ),
      "addtional_price",
    );
  }

  get addtinals() {
    return this.order.order_units.filter((unit) =>
      Number.parseInt(unit.addtional_price),
    );
  }

  get deliveryTypes() {
    return this.order.order_units.filter(
      (unit) =>
        unit.delivery_type === "yamato" || unit.delivery_type === "sagawa",
    );
  }

  @auth.Getter
  public getToken: string;
  @auth.Getter
  public getUserLogging: any;
  public isShow = false;
  public order: any = {};
  public form: any = {
    comment: "",
  };
  public files: any = [];
  public errors = {};

  public chat: any = {};

  public fileList: any = [];

  public chatRecordFiles: any = [];

  public statusOrderBeforeUpdate: string = null;

  public deliveryType: string = null;
  public deliveryTypeDelivery: string =
    DELIVERY_TYPES_NAME[DELIVERY_TYPES.DELIVERY];
  public deliveryTypeStore: string = DELIVERY_TYPES_NAME[DELIVERY_TYPES.STORE];

  public uploadOptions = {
    maxFilesize: 5, // 5mb
    acceptedFiles: ".jpg, .jpeg, .png, .pdf, .doc, .excel",
  };
  public uploading = false;
  public chatTemplate = "";
  public connection: WebSocket;
  public connectionId = null;
  public statusOrder = null;

  public sockTimer;
  public printChat() {
    this.$emit("print", this.order.id);
  }

  public getNaritaUrl(url) {
    return url;
  }

  public getNo1koiUrl(url) {
    return url;
  }

  public show(order) {
    this.chat = {
      chat_records: [],
    };
    this.statusOrder = null;
    this.form.comment = "";
    this.resetFile();
    this.order = order;
    this.statusOrderBeforeUpdate = this.order.status;
    if (this.order.delivery_type) {
      this.deliveryType = DELIVERY_TYPES_NAME[this.order.delivery_type];
    }
    this.connectSocket();
    this.getMessage();
    this.isShow = true;
  }

  public async getMessage() {
    const result = await chatApi.adminChatList({
      order_id: this.order.id,
    });

    this.chat = result.data.chat ? result.data.chat : this.chat;

    this.moveToBottom();
  }

  public async connectSocket() {
    const result = await chatApi.adminChatConnectSocketUrl({
      order_id: this.order.id,
    });

    if (result.data.connect_socket_url) {
      this.connection = new WebSocket(result.data.connect_socket_url);
      this.connection.addEventListener("message", (event: MessageEvent) => {
        const data = JSON.parse(event.data);
        if (data.action === "subcribe") {
          this.connectionId = data.connectionId;
        } else if (
          data.action === "publish" &&
          this.connectionId !== data.connectionId
        ) {
          if (data.event === "markAsRead") {
            this.chat.chat_records = this.chat.chat_records.map((record) => {
              if (record.user_id) {
                return { ...record, is_readed: true };
              }
              return record;
            });
            return;
          }
          for (const chatRecord of data.chat_records) {
            const result = this.chat.chat_records.findIndex(
              (object) => object.uuid == chatRecord.uuid,
            );

            if (result < 0) {
              chatRecord.uuid = null;
              chatRecord.is_readed = false;
              chatRecord.member_id = true;
              this.chat.chat_records = [...this.chat.chat_records, chatRecord];
              this.order.is_read = false;
              this.chat.chat_records = this.chat.chat_records.map((record) => {
                if (record.user_id) {
                  return { ...record, is_readed: true };
                }
                return record;
              });
            } else {
              this.chat.chat_records[result].uuid = null;
              this.chat.chat_records[result].is_readed = false;
              this.chat.chat_records[result].created_at = chatRecord.created_at;
            }
          }
          this.moveToBottom();
        }
      });
      this.connection.addEventListener("open", () => {
        console.log("connect socket is success");
        const body: any = {
          action: "subscribe",
          topic: "order/" + this.order.id,
        };

        this.connection.send(JSON.stringify(body));
        this.ping();
      });
    }
  }

  public ping() {
    this.connection.send(
      JSON.stringify({
        action: "publish",
        topic: "ping",
        event: "ping",
      }),
    );
    this.sockTimer = setTimeout(this.ping, 5000);
  }

  public moveToBottom() {
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$el.querySelector(".chatPopup").scrollTop = this.$el.querySelector(
          ".chatPopup",
        ).scrollHeight;
      }, 10);
    });
  }

  public async send() {
    if (!this.form.comment && this.chatRecordFiles.length === 0) {
      return;
    }

    let result;
    try {
      const uuid = uuidv4();
      if (this.chatRecordFiles.length > 0) {
        this.chat.chat_records = [
          ...this.chat.chat_records,
          ...this.chatRecordFiles,
        ];
      }
      if (this.form.comment) {
        const chatRecord = {
          comment: this.form.comment,
          user_id: this.getUserLogging.id,
          created_at: moment(),
          uuid,
          is_readed: false,
        };
        this.chat.chat_records = [...this.chat.chat_records, chatRecord];
      }
      this.moveToBottom();
      if (this.statusOrder) {
        await this.changeStatus(this.order.id, this.statusOrder, true);
        this.statusOrder = null;
      }
      const comment = cloneDeep(this.form.comment);
      this.form.comment = null;
      this.chatRecordFiles = [];

      if (!this.order.is_read) {
        chatApi.adminChatIsReaded({
          disabledLoadinng: true,
          order_id: this.order.id,
          is_readed: true,
        } as any);
      }

      result = await chatApi.adminChatSave({
        disabledLoadinng: true,
        id: this.chat.id,
        order_id: this.order.id,
        member_id: this.order.member.id,
        comment,
        file_list: this.fileList,
        uuid,
      } as any);
      this.chat.chat_records = this.chat.chat_records.map((record) => {
        if (!record.user_id) {
          return { ...record, is_readed: true };
        }
        return record;
      });
      this.fileList = [];
      (this.$refs.myVueDropzone as uploadFile).reset();
    } catch (error: any) {
      console.log(error);
      result = error.body;
      QNotify.error({
        text: result.message,
      });
      this.errors = result.errors;
    }
  }

  public destroy() {
    if (this.connection) {
      this.connection.close();
      clearInterval(this.sockTimer);
    }
  }

  public closePopup() {
    if (this.connection) {
      this.connection.close();
      clearInterval(this.sockTimer);
    }
    this.resetFile();
    this.isShow = false;
    this.$emit("close");
  }

  public pushError(message) {
    this.errors = {
      ...this.errors,
      ...{ uploadFiles: message },
    };
  }
  public async changeFile(files) {
    this.fileList = files.map((file) => {
      return file.id || !file.upload
        ? file
        : {
          extension: file.extension,
          name: file.filePath,
          original_name: file.upload.filename,
          container: "File",
          size: file.upload.bytesSent,
          mime_type: file.mimeType,
          uuid: uuidv4(),
        };
    });
    this.chatRecordFiles = [];
    for (const file of this.fileList) {
      const chatRecord = {
        [["png", "jpeg", "jpg"].includes(file.extension) ? "image" : "file"]: {
          name: file.name,
          original_name: file.original_name,
        },
        user_id: this.getUserLogging.id,
        created_at: moment(),
        uuid: file.uuid,
        is_readed: false,
      };

      this.chatRecordFiles.push(chatRecord);
    }
  }

  public formatImageUrl(fileName) {
    return formatImageUrl(fileName, "", "contain");
  }

  public formatFileUrl(fileName) {
    return formatFileUrl(fileName);
  }

  public openFile() {
    (this.$refs.myVueDropzone as uploadFile).open();
  }

  public async setAmountConfirmTemplate() {
    await this.getDetail();
    this.form.comment = (this.$refs.amountConfirmTmp as any).innerHTML;
    this.statusOrder = STATUSES.PACKING;
  }

  public async sendTemplate() {
    await this.getDetail();
    this.form.comment = (this.$refs.sendTmp as any).innerHTML;
    this.statusOrder = STATUSES.SENTED;
  }

  public async setAmountConfirmTemplateEn() {
    await this.getDetail();
    this.form.comment = (this.$refs.amountConfirmTmpEn as any).innerHTML;
    this.statusOrder = STATUSES.PACKING;
  }

  public async sendTemplateEn() {
    await this.getDetail();
    this.form.comment = (this.$refs.sendTmpEn as any).innerHTML;
    this.statusOrder = STATUSES.SENTED;
  }

  public async getDetail() {
    const result = await CarpsaleHistoryManagementCarpsaleHistoryService.adminCarpsaleHistoryShow(
      {
        id: this.order.id,
      },
    );
    this.order = result.data.order;
  }

  public async setMoneyTemplate() {
    await this.getDetail();
    this.form.comment = (this.$refs.moneyTmp as any).innerHTML;
  }

  public async setShippingTemplate() {
    await this.getDetail();
    this.form.comment = (this.$refs.shippingTmp as any).innerHTML;
  }

  public sumAmount(target, type) {
    let sum = 0;
    for (const unit of target) {
      sum += Number.parseInt(unit[type] ? unit[type] : 0);
    }
    return sum;
  }

  public formatJpDate(deliveryPreferredDate) {
    const confirmedDatetime = new Date();
    if (deliveryPreferredDate) {
      const date = min([
        moment(deliveryPreferredDate).subtract(1, "days"),
        moment(confirmedDatetime).add(7, "days"),
      ]);
      return moment(date).format(DATE_TIME_TEXT_FORMAT);
    } else {
      const date = moment(confirmedDatetime).add(7, "days");
      return moment(date).format(DATE_TIME_TEXT_FORMAT);
    }
  }

  public formatEnDate(deliveryPreferredDate) {
    const confirmedDatetime = new Date();
    if (deliveryPreferredDate) {
      const date = min([
        moment(deliveryPreferredDate).subtract(1, "days"),
        moment(confirmedDatetime).add(7, "days"),
      ]);
      return moment(date).format(DATE_TIME_FORMAT_SLASH);
    } else {
      const date = moment(confirmedDatetime).add(7, "days");
      return moment(date).format(DATE_TIME_FORMAT_SLASH);
    }
  }

  public isBank(paymentType) {
    return paymentType === PAYMENT_TYPES.BANK;
  }

  public isCod(paymentType) {
    return paymentType === PAYMENT_TYPES.COD;
  }

  public IsDirect(paymentType) {
    return paymentType === PAYMENT_TYPES.DIRECT;
  }

  public getShippingUrl(shippingNumber) {
    return getShippingUrl(shippingNumber);
  }

  public getShippingYamatoUrl(shippingNumber) {
    return getShippingYamatoUrl(shippingNumber);
  }

  public async editIsReaded() {
    try {
      await chatApi.adminChatIsReaded({
        order_id: this.order.id,
        is_readed: true,
      });
      QNotify.success({
        text: this.$t("common.message.updated"),
      });
      this.getMessage();
      window.dispatchEvent(new CustomEvent("reload-notice"));
    } catch (error: any) {
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public async changeStatus(orderId, status, disabledLoadinng = false) {
    try {
      await chatApi.adminChatOrderStatus({
        disabledLoadinng,
        order_id: orderId,
        status,
      } as any);
      this.order.status = status;
      if (
        this.statusOrderBeforeUpdate === STATUSES.INITIAL &&
        status === STATUSES.RESERVED
      ) {
        this.getMessage();
      }
      this.statusOrderBeforeUpdate = status;
      QNotify.success({
        text: this.$t("common.message.updated"),
      });
    } catch (error: any) {
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public async changeChatStatus(isClose: boolean) {
    try {
      await chatApi.adminChatChatStatus({
        order_id: this.order.id,
        is_close: isClose,
      });
      QNotify.success({
        text: this.$t("common.message.updated"),
      });

      if (isClose) {
        this.closePopup();
      } else {
        this.getMessage();
      }
    } catch (error: any) {
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public async viewFile(fileName) {
    const { data } = await awsApi.awsDownloadFilePresign({
      filePath: fileName,
    });
    window.open(data.presign.url, "_blank");
  }

  public spacePadding(value: string, length_: number) {
    if (this.count(value) > length_) {
      return value;
    }
    const length__ = length_ - this.count(value);
    for (let index = 0; index < length__; index++) {
      value = value + " ";
    }

    return value;
  }

  public count(string: string) {
    let length_ = 0;
    for (const element of string) {
      /[ -~]/.test(element) ? (length_ += 1) : (length_ += 2);
    }

    return length_;
  }

  public getLiveCarpName(item) {
    if (item) {
      return `
    ${item.kind ? item.kind : "--"}/${item.age?.name ? item.age?.name : "--"}/${
  item.sex_name ? item.sex_name : "--"
}/${item.size ? item.size : "--"}cm
    `;
    }
  }

  public getLiveCarpNameEn(item) {
    if (item) { return item.sub_name_en; }
  }

  public getTypeBusiness() {
    return TYPES.BUSINESS;
  }

  public calcTotalGivePoint(order) {
    const orderDetails = order.order_details;
    let totalGivePoint = 0;
    for (const detail of orderDetails) {
      if (detail.is_give_point == true) {
        totalGivePoint += detail.sub_total;
      }
    }
    totalGivePoint = totalGivePoint - order.used_points;

    return totalGivePoint > 0 ? Math.round(totalGivePoint / 100) : 0;
  }

  public calcTotalAfterAdd(memberPoints, orderId) {
    if (memberPoints.length > 0) {
      const isAddPoint = memberPoints.some(
        (memberPoint) => memberPoint.give_order_id === orderId,
      );
      const point = memberPoints[memberPoints.length - 1].point;
      return isAddPoint ? point : this.calcTotalGivePoint(this.order) + point;
    } else {
      return this.calcTotalGivePoint(this.order);
    }
  }

  public removeFile(id) {
    this.chatRecordFiles = this.chatRecordFiles.filter(
      (file) => file.uuid !== id,
    );
    this.fileList = this.fileList.filter((file) => file.uuid !== id);
    this.files = this.files.filter((file) => file.upload.uuid !== id);
  }

  public resetFile() {
    this.chatRecordFiles = [];
    this.fileList = [];
    this.files = [];
  }
}
